// Generic sort + limit tools. Work on either raw dataset rows or
// grouped rows ({ group, value, rows }) produced by groupBy().

function resolveSortField(data, by) {

  if (by) return by;

  // If the data looks like grouped rows, default to sorting by "value".
  if (data.length && Object.prototype.hasOwnProperty.call(data[0], "value")) {
    return "value";
  }

  return null;
}

export function sortData(data, by, direction = "desc") {

  if (!Array.isArray(data) || !data.length) {
    return [];
  }

  const field = resolveSortField(data, by);

  if (!field) {
    throw new Error("sort requires a column to sort by.");
  }

  const sorted = [...data].sort((a, b) => {

    const aVal = a[field];
    const bVal = b[field];

    const aNum = Number(aVal);
    const bNum = Number(bVal);

    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);

    let cmp;

    if (bothNumeric) {
      cmp = aNum - bNum;
    } else {
      cmp = String(aVal ?? "").localeCompare(String(bVal ?? ""));
    }

    return direction === "asc" ? cmp : -cmp;
  });

  return sorted;
}

// top/bottom: if the data isn't already sorted appropriately, sort it first
// (defaulting to the "value" field for grouped data), then slice.
export function limitData(data, n = 5, { by, direction = "desc", alreadySorted = false } = {}) {

  if (!Array.isArray(data) || !data.length) {
    return [];
  }

  const source = alreadySorted
    ? data
    : sortData(data, by, direction);

  return source.slice(0, n);
}
